import { Injectable } from '@angular/core';
import { ExternalDeviceGraphData } from '@cropx-common/components/graphs/rain-gauge-graph/models/RainGaugeGraphModel';
import {
  Action,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';
import { Observable, of } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace WeatherStationData {
  const type = 'weatherStationData';

  export class SetTemperatureMeasurementData {
    static readonly type = `[${type}] SetTemperatureMeasurementData`;

    constructor(public data: ExternalDeviceGraphData[]) {}
  }

  export class SetHumidityMeasurementData {
    static readonly type = `[${type}] SetHumidityMeasurementData`;

    constructor(public data: ExternalDeviceGraphData[]) {}
  }

  export class SetRainfallMeasurementData {
    static readonly type = `[${type}] SetRainfallMeasurementData`;

    constructor(public data: ExternalDeviceGraphData[]) {}
  }

  export class SetWindMeasurementData {
    static readonly type = `[${type}] SetWindMeasurementData`;

    constructor(public data: ExternalDeviceGraphData[]) {}
  }

  export class SetETMeasurementData {
    static readonly type = `[${type}] SetETMeasurementData`;

    constructor(public data: ExternalDeviceGraphData[]) {}
  }
}

export interface WeatherStationDataStateModel {
  temperatureData: ExternalDeviceGraphData[];
  windData: ExternalDeviceGraphData[];
  etData: ExternalDeviceGraphData[];
  rainfallData: ExternalDeviceGraphData[];
  humidityData: ExternalDeviceGraphData[];
}

@State<WeatherStationDataStateModel>({
  name: 'weatherStationData',
  defaults: {
    temperatureData: null,
    windData: null,
    etData: null,
    rainfallData: null,
    humidityData: null,
  },
})
@Injectable()
export class WeatherStationDataState {
  @Action(WeatherStationData.SetRainfallMeasurementData)
  setRainfallMeasurementData(
    ctx: StateContext<WeatherStationDataStateModel>,
    action: WeatherStationData.SetRainfallMeasurementData,
  ): Observable<ExternalDeviceGraphData[]> {
    ctx.patchState({ rainfallData: action.data });
    return of(action.data);
  }

  @Action(WeatherStationData.SetETMeasurementData)
  setETMeasurementData(
    ctx: StateContext<WeatherStationDataStateModel>,
    action: WeatherStationData.SetETMeasurementData,
  ): Observable<ExternalDeviceGraphData[]> {
    ctx.patchState({ etData: action.data });
    return of(action.data);
  }

  @Action(WeatherStationData.SetHumidityMeasurementData)
  setHumidityMeasurementData(
    ctx: StateContext<WeatherStationDataStateModel>,
    action: WeatherStationData.SetHumidityMeasurementData,
  ): Observable<ExternalDeviceGraphData[]> {
    ctx.patchState({ humidityData: action.data });
    return of(action.data);
  }

  @Action(WeatherStationData.SetTemperatureMeasurementData)
  setTemperatureMeasurementData(
    ctx: StateContext<WeatherStationDataStateModel>,
    action: WeatherStationData.SetTemperatureMeasurementData,
  ): Observable<ExternalDeviceGraphData[]> {
    ctx.patchState({ temperatureData: action.data });
    return of(action.data);
  }

  @Action(WeatherStationData.SetWindMeasurementData)
  setWindMeasurementData(
    ctx: StateContext<WeatherStationDataStateModel>,
    action: WeatherStationData.SetWindMeasurementData,
  ): Observable<ExternalDeviceGraphData[]> {
    ctx.patchState({ windData: action.data });
    return of(action.data);
  }
}

export class WeatherStationDataStateSelectors {
  static slices = createPropertySelectors<WeatherStationDataStateModel>(
    WeatherStationDataState,
  );
}
